// extracted by mini-css-extract-plugin
export default {"richTextPreviewerWrapper":"RichTextPreviewer_richTextPreviewerWrapper__8jp45","paragraph":"RichTextPreviewer_paragraph__3LmQ1"};